import { render, staticRenderFns } from "./HeaderTrending.vue?vue&type=template&id=93037f42&"
import script from "./HeaderTrending.vue?vue&type=script&lang=js&"
export * from "./HeaderTrending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports